import React, { useRef } from 'react';
import { Dropdown } from 'components/molecules/dropdown';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Card } from 'components/atoms/Card';
import { LayoutList, SquareKanban, Table } from 'lucide-react';
import PropTypes from 'prop-types';
import { ToolbarButton } from './toolbarButton';

export const LayoutToolbar = ({ page, view, toolbarOptionChange, label }) => {
  const ref = useRef(null);

  const options = [
    {
      title: 'Table',
      icon: Table,
      value: 'table',
    },
    {
      title: 'Cards',
      icon: LayoutList,
      value: 'card',
    },
    ...(page === 'list'
      ? [
          {
            title: 'Board',
            icon: SquareKanban,
            value: 'board',
          },
        ]
      : []),
  ];

  const selectedOption = options.find((option) => option.value === view);

  return (
    <Flex>
      <Dropdown
        ref={ref}
        triggerProps={{
          variant: 'tertiary',
          size: 'sm',
        }}
        placement="bottom-start"
        trigger={({ isOpen }) => (
          <Flex sx={{ alignItems: 'center' }}>
            <ToolbarButton
              option={{
                ...selectedOption,
                label,
              }}
              active={isOpen}
            />
          </Flex>
        )}
      >
        <Card width="160px" py="8px" px="0px">
          {options.map((option) => (
            <Flex
              sx={{ gap: '8px', p: '4px 16px', alignItems: 'center', cursor: 'pointer' }}
              key={option.title}
              onClick={() => {
                toolbarOptionChange('view', option);
                ref.current.closeDropdown();
              }}
            >
              <Box as={option.icon} size="16px" />
              <Text color="text.main" fontSize="14px" lineHeight="24px" fontWeight="400">
                {option.title}
              </Text>
            </Flex>
          ))}
        </Card>
      </Dropdown>
    </Flex>
  );
};

LayoutToolbar.propTypes = {
  page: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  toolbarOptionChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
